import { gql } from 'graphql-request';

const deleteAddress = gql`
  mutation DeleteBillingAddress {
    deleteBillingAddress {
      billingAddress {
        id
        state
        zip
      }
    }
  }
`;

const deleteCurrentUser = gql`
  mutation DeleteCurrentUser {
    deleteCurrentUser {
      success
    }
  }
`;

const deletePaymentMethod = gql`
  mutation DeletePaymentMethod($nonce: String, $token: String) {
    deletePaymentMethod(nonce: $nonce, token: $token) {
      success
    }
  }
`;

const updateAccountInfo = gql`
  mutation UpdateAccountInfo($firstName: String!, $lastName: String!, $email: String!, $countryCode: String!) {
    updateAccountInfo(firstName: $firstName, lastName: $lastName, email: $email, countryCode: $countryCode) {
      currentUser {
        email
      }
    }
  }
`;

const updateAddress = gql`
  mutation UpdateBillingAddress(
    $state: String!
    $zip: String!
    $countryCode: String
    $firstName: String
    $lastName: String
  ) {
    updateBillingAddress(
      state: $state
      zip: $zip
      countryCode: $countryCode
      firstName: $firstName
      lastName: $lastName
    ) {
      billingAddress {
        id
        state
        zip
      }
      currentUser {
        countryCode
        firstName
        lastName
      }
    }
  }
`;

const updatePassword = gql`
  mutation UpdatePassword($currentPassword: String!, $newPassword: String!, $confirmPassword: String!) {
    updatePassword(currentPassword: $currentPassword, newPassword: $newPassword, confirmPassword: $confirmPassword) {
      currentUser {
        id
      }
    }
  }
`;

export const accountMutations = {
  deleteAddress,
  deleteCurrentUser,
  deletePaymentMethod,
  updateAccountInfo,
  updateAddress,
  updatePassword,
};
